import React from 'react';

export default () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.66536 9.33325H8.66536C10.1381 9.33325 11.332 8.13934 11.332 6.66659C11.332 5.19383 10.1381 3.99992 8.66536 3.99992H5.33203V11.9999H6.66536V9.33325ZM8.66536 5.33325H6.66536V7.99992H8.66536C9.40174 7.99992 9.9987 7.40297 9.9987 6.66659C9.9987 5.93021 9.40174 5.33325 8.66536 5.33325Z"
      fill="#261B36"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.33203 1.33325V14.6666H14.6654V1.33325H1.33203ZM13.332 2.66659H2.66536V13.3333H13.332V2.66659Z"
      fill="#261B36"
    />
  </svg>
);
